// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"b41b7d92","394":"75dd7b35","453":"c36b6530","621":"078dbebb","677":"06241fb3","679":"21dbf925","693":"617201ce","877":"0c11afa4","928":"9088a0d1"}[chunkId] + ".chunk.js";
};